import React, { PropsWithChildren } from 'react';
import { Box, BoxProps } from '@indeed/ifl-components';

export type ColProps = PropsWithChildren<Omit<BoxProps, 'as'>>;

const Col = ({ sx = {}, ...rest }: ColProps): React.JSX.Element => {
    return (
        <Box
            sx={{
                position: 'relative',
                paddingBlock: 0,
                paddingInline: 4,
                inlineSize: '100%',
                maxInlineSize: '100%',
                flex: '0 0 100%',
                ...sx,
            }}
            {...rest}
        />
    );
};

export default Col;
